import React from 'react'
import '../assets/css/components/large-loading-notice.css'
import loadingGif from '../assets/img/loading-pinwheel.gif'
import tytoonline from '../assets/img/Tyto-Online-Logo.png'

const LargeLoadingNotice = ({ title }) => {
	return (
		<div className='full-page-notice' data-testid='full-page-notice-loading'>
			<img className='logo' src={tytoonline} alt='tyto-online logo' />
			{title}
			<img src={loadingGif} className='loading' alt='loading gif' />
		</div>
	)
}

export default LargeLoadingNotice
